module.exports = __webpack_public_path__ + "static/media/Alpha-iQ-tm-RA-6300-iQ.937f0395.png";